import { render } from "./FrameComponent.vue?vue&type=template&id=b1909910"
import script from "./FrameComponent.vue?vue&type=script&lang=js"
export * from "./FrameComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jjviglio/OpenMCT/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__